import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { XCircle, ArrowLeft } from 'lucide-react';

export default function PaymentCancel() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-rose-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full p-8 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-slate-200 mb-5">
          <XCircle className="w-8 h-8 text-slate-600" />
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-2">{t('payment.cancelTitle')}</h1>
        <p className="text-slate-600 mb-6">{t('payment.cancelBody')}</p>
        <div className="space-y-2">
          <Link to="/pricing">
            <Button className="w-full">
              {t('payment.tryAgain')}
            </Button>
          </Link>
          <Link to="/dashboard">
            <Button variant="ghost" className="w-full">
              <ArrowLeft className="w-4 h-4 mr-1" /> Dashboard
            </Button>
          </Link>
        </div>
      </Card>
    </div>
  );
}
